import { render, staticRenderFns } from "./TenMinuteSong.vue?vue&type=template&id=32c27cb8&scoped=true&"
import script from "./TenMinuteSong.vue?vue&type=script&lang=js&"
export * from "./TenMinuteSong.vue?vue&type=script&lang=js&"
import style0 from "./TenMinuteSong.vue?vue&type=style&index=0&id=32c27cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c27cb8",
  null
  
)

component.options.__file = "TenMinuteSong.vue"
export default component.exports